import React from "react";

import loader from './images/loader.svg';

function TypingLoader() {
    return (
        <div className="rcw-custom-response-message">
            <img
                src={loader}
                className="rcw-typing-loader"
                alt="typing"
            />
        </div>
    );
}

export default TypingLoader;